import React from "react";

const WhayUseSection = () => {
	const data = [
		{
			id: 1,
			color: "bg-orange text-orange",
			icon: "fas fa-user-tie fs-5",
			title: "Online Learning",
			deskripsi:
				"Mulailah meningkatkan pengetahuan dan kemampuan Anda melalui fitur online learning kami yang menawarkan pengalaman belajar yang interaktif dan menyenangkan.",
		},
		{
			id: 2,
			color: "bg-info text-info",
			icon: "fas fa-book fs-5",
			title: "Gamifikasi",
			deskripsi:
				"Fitur gamifikasi adalah sebuah strategi yang mengadaptasi elemen permainan ke dalam konteks non-permainan untuk meningkatkan motivasi, keterlibatan, dan kesenangan pengguna.",
		},
		{
			id: 3,
			color: "bg-success text-success",
			icon: "bi bi-alarm-fill fs-5",
			title: "E-Sertifikat",
			deskripsi:
				"Dapatkan pengakuan resmi atas kemampuan dan pengetahuan Anda melalui fitur E-sertifikat kami yang memberikan sertifikat berkualitas tinggi dan dapat diakses kapan saja, di mana saja.",
		},
		{
			id: 4,
			color: "bg-danger text-danger",
			icon: "fas fa-university fs-5",
			title: "Konten Relevan",
			deskripsi:
				"Pelajari topik yang Anda butuhkan dengan fitur konten yang relevan kami, yang menyediakan materi terkini dan terverifikasi untuk membantu Anda mencapai tujuan belajar Anda.",
		},
	];

	return (
		<section>
			<div className="container">
				<div className="row g-4 align-items-center">
					<div className="col-lg-5">
						<h2>
							Satu Aplikasi Untuk{" "}
							<span className="text-primary"> Beragam Kebutuhan </span>
						</h2>
						<img
							src="assets/images/asset-kg/KGB00591-why.jpg"
							className="rounded-2"
							alt="about"
						/>
					</div>
					<div className="col-lg-7 ps-4">
						<div className="row g-4">
							{data.map((x) => (
								<div className="col-sm-6" key={x.id}>
									<div className={`icon-lg bg-opacity-10 rounded-2 ${x.color}`}>
										<i className={x.icon} />
									</div>
									<h5 className="mt-2">{x.title}</h5>
									<p className="mb-0">{x.deskripsi}</p>
								</div>
							))}
						</div>
					</div>
				</div>
			</div>
		</section>
	);
};

export default WhayUseSection;
